﻿import React, { useState, useEffect } from 'react';
import { IonChromatographyIonDatum } from '../models/ion-chromatography-ion-datum';
import { LookupItem } from '../models/lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ToastProps } from '../models/toast-props';
import { EditType, MessageBoxReplyType, ModalMessageType } from '../models/enums';
import { MessageBoxReply } from '../models/message-box-reply';

import Guid from 'devextreme/core/guid';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

import { ReactGrid, Id, CellChange, TextCell, Column, Row, Range, DefaultCellTypes } from "@silevis/reactgrid";

import "@silevis/reactgrid/styles.css";

const ION_CHROMATOGRAPHY_ION_DATUM_COLUMN_IDX = 0;
const EDIT_TYPE_COLUMN_ID = "editType";
const UNSAVED_CHANGES_WARNING = 100;

const initColumns: Column[] = [
    { columnId: "ionChromatographyDataId ", width: -20 },
    { columnId: EDIT_TYPE_COLUMN_ID, width: -20 },
    { columnId: "elution", width: 80, resizable: true },
    { columnId: "analyte", width: 250, resizable: true },
    { columnId: "resultString", width: 180, resizable: true },
    { columnId: "retentionTime", width: 180, resizable: true }
    //{ columnId: "Dummy", width: 20 }
];

const headerRow: Row = {
    rowId: "header",
    cells: [
        { type: "header", text: "", className: "reactgrid-hidden-column" },
        { type: "header", text: "", className: "" },
        { type: "header", text: "Elution", className: "reactgrid-header-cell" },
        { type: "header", text: "Analyte", className: "reactgrid-header-cell" },
        { type: "header", text: "Result", className: "reactgrid-header-cell" },
        { type: "header", text: "Retention Time", className: "reactgrid-header-cell" },
      //  { type: "header", text: "", className: "" },
    ]
};

/*
ionChromatographyDataId ?: string;
benchSheetId ?: string;
elution ?: number | null;
analyte ?: string;
result ?: number | null;
uom ?: LookupItem;
uomId ?: number;
uomString ?: string;
uomUnit ?: number;
retentionTime ?: number | null;
*/

let key = 1;

const decimalFormat = {
    type: "fixedPoint",
    precision: 4
}

export interface Props {
    benchSheetId?: string;
    onClose?: () => void;
}

export default function IonChromatographyIonDataComponent(props: Props) {
    const [ionData, setIonData] =
        useState<IonChromatographyIonDatum[]>();

    const [rows, setRows] =
        useState<Row[]>();

    const [columns, setColumns] =
        useState<Column[]>(initColumns);

    const [selectedIonChromatographyDataId, setSelectedIonChromatographyDataId] =
        useState<string>();

    const [uoms, setUoms] =
        useState<LookupItem[]>();

    const [selectedIonData, setSelectedIonData] =
        useState<IonChromatographyIonDatum>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
            
    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getRows();
    }, [ionData]);


    key++;

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">
                    <Button text="Add Row" icon="plus" type="success"
                        className="pw-button" height='1.8rem'
                        hint="add row"
                        onClick={onAddRowClick} />

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button" height='1.8rem'
                        hint="save changes"
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button" height='1.8rem'
                        hint="close dialog"
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <ReactGrid
                    enableFillHandle={true}
                    enableRangeSelection={true}
                    rows={rows ? rows : []} columns={columns}
                    onSelectionChanging={onSelectionChanging}
                    onColumnResized={handleColumnResize}
                    onCellsChanged={handleChanges} />
            </div>

            {/*
            <div className="pw-datagrid">
                <DataGrid
                    keyExpr="ionChromatographyDataId"
                    wordWrapEnabled={true}
                    width="100%"
                    onSelectionChanged={onSelectionChanged}
                    onRowValidating={onIonDataValidating}
                    onRowRemoving={onIonDataRowRemoving}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    dataSource={ionData ? ionData : []}
                    showBorders={true}>

                    <SearchPanel visible={true} />
                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <Paging enabled={false} />

                    <Column name="bc0" type="buttons" width='4rem'>
                        <ColumnButton hint="delete" icon="trash"
                            onClick={onIonDataRowRemoving} />
                        <ColumnButton hint="certificate" icon="info"
                            onClick={onIonDatumInfoButtonClick} />
                    </Column>

                    <Column width='2rem' cssClass="table-vertical-align"
                        cellRender={editMarkerCellRender} />

                    <Column dataField={'elution'} dataType="number" width={'8rem'} alignment='center' />
                    <Column dataField={'analyte'} />
                    <Column dataField={'result'} dataType="number" format={decimalFormat} width={'12rem'} />

                    <Column dataField={'uomId'} width={'8rem'}  > 
                        <Lookup dataSource={uoms ? uoms : []} valueExpr="id" displayExpr='name' />
                    </Column>

                    <Column dataField={'retentionTime'} dataType="number" format={decimalFormat} width={'12rem'} />

                    <Editing mode="cell"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true} />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Ion Data</div>
                            </div>
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button width='1.9rem' type='normal' icon="repeat"
                                hint="duplicate rows"
                                onClick={duplicateIonDataRow} />
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button width='1.9rem' type='normal' icon="plus"
                                hint="add ion data row"
                                onClick={onAddIonDataRowClick} />
                        </ToolBarItem>
                    </Toolbar>

                </DataGrid>
            </div>
            */}

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onReply={onGlobalDialogReply} onClose={onGlobalDialogClose} />
            }

        </div>
    );

    function onSaveClick() {
        saveIonData();
    }

    function onCloseClick() {
        const anyNonSavedChanges = ionData.some(a => a.editType !== EditType.None);

        if (anyNonSavedChanges) {
            showPromptMessage(ModalMessageType.PromptYesNo,
                "Unsaved Items",
                "You have unsaved changes. Do you want to close anyway?",
                UNSAVED_CHANGES_WARNING);

            return;
        }

        closeDialog();
    }

    function closeDialog() {
        if (props.onClose)
            props.onClose();
    }

    function handleColumnResize(ci: Id, width: number) {
        if (!columns)
            return;

        setColumns((prevColumns) => {
            const columnIndex = prevColumns.findIndex(el => el.columnId === ci);
            const resizedColumn = prevColumns[columnIndex];
            const updatedColumn = { ...resizedColumn, width };
            prevColumns[columnIndex] = updatedColumn;
            return [...prevColumns];
        });
    }

    function onAddRowClick() {
        let elution = 1;

        if (ionData)
            elution = ionData.length + 1;

        let editedIonData = [...ionData];
        let newIonDatum: IonChromatographyIonDatum = { ionChromatographyDataId: new Guid().toString(), elution: elution, editType: EditType.Insert };

        editedIonData.push(newIonDatum);

        setIonData(editedIonData);
    }

    function onSelectionChanging(selectedRanges: Range[]): boolean {
        //console.log("onSelectionChanging");
        //console.log(selectedRanges);

        if (selectedRanges && selectedRanges.length > 0 &&
            selectedRanges[0].columns && selectedRanges[0].columns.length > 0 &&
            selectedRanges[0].rows && selectedRanges[0].rows.length > 0) {

            const rowId = selectedRanges[0].rows[0].rowId;

            //console.log("rowId:");
            //console.log(rowId);

            const selectedIonDatumCell = selectedRanges[0].first.row.cells[ION_CHROMATOGRAPHY_ION_DATUM_COLUMN_IDX] as any;
            const selectedIonChromatographyDataId = selectedIonDatumCell.text;

            //console.log("solventId:");
            //console.log(solventId);
            setSelectedIonChromatographyDataId(selectedIonChromatographyDataId);
        }

        return true;
    }

    function handleChanges(changes: CellChange<TextCell>[]) {
        setIonData((prevIonData) => applyChangesToIonData(changes, prevIonData));
    };

    function applyChangesToIonData(changes: CellChange<TextCell>[], prevIonData: IonChromatographyIonDatum[]): IonChromatographyIonDatum[] {
        //console.log("changes:");
        //console.log(changes);

        changes.forEach((change) => {
            const readingIndex = change.rowId;
            const fieldName = change.columnId;

            prevIonData[readingIndex][fieldName] = change.newCell.text;

            if (prevIonData[readingIndex].editType !== EditType.Insert)
                prevIonData[readingIndex].editType = EditType.Update;
        });

        return [...prevIonData];
    };

    /*
    function onSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedIonData(e.selectedRowsData[0]);
        }
    }
    */

   /*
    function duplicateIonDataRow() {
        if (selectedIonData) {
            let editedIonData = [...ionData];

            let newIonDataEntry: IonChromatographyIonDatum = { ...selectedIonData };

            newIonDataEntry.editType = EditType.Insert;
            newIonDataEntry.ionChromatographyDataId = new Guid().toString();

            editedIonData.push(newIonDataEntry);

            setIonData(editedIonData);
        }
    }

    function onAddIonDataRowClick() {
        let newElutionNumber = 1;

        if (ionData)
            newElutionNumber = ionData.length + 1;

        let newIonDataEntry: IonChromatographyIonDatum = {
            ionChromatographyDataId: new Guid().toString(),
            elution: newElutionNumber,
            editType: EditType.Insert
        };

        let editedIonData = [...ionData];

        editedIonData.push(newIonDataEntry);

        editedIonData.sort((a, b) => a.elution - b.elution);

        setIonData(editedIonData);
    }
    */

    async function saveIonData() {
        if (!ionData)
            return;

        let preparedIonData = [...ionData];

        console.log("preparedIonData... BEGIN");
        console.log(preparedIonData);

        preparedIonData.forEach(d => {
            d.benchSheetId = props.benchSheetId;
        });

        console.log("preparedIonData...AFTER");
        console.log(preparedIonData);

        await updateIonData(preparedIonData)
            .then(() => {
                getIonData();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Ion Data");
            });
    }

    /*
    async function onIonDataValidating(e: any) {
        if (e.oldData && e.oldData.editType !== EditType.Insert)
            e.newData.editType = EditType.Update;
    }

    function onIonDataRowRemoving(e: any) {
        console.log("onIonDataRowRemoving");
        console.log(e);

        if (e.row && e.row.data && e.row.data.ionChromatographyDataId) {
            let editedIonData = [...ionData];

            let matchingIonDatum = editedIonData.find(d => d.ionChromatographyDataId === e.row.data.ionChromatographyDataId);

            if (matchingIonDatum) {
                //if element was just added but not saved, just get rid of it
                if (matchingIonDatum.editType === EditType.Insert) {
                    const idx = editedIonData.findIndex(d => d.ionChromatographyDataId === e.row.data.ionChromatographyDataId);

                    if (typeof idx === 'number')
                        editedIonData.splice(idx, 1);
                }
                else {
                    matchingIonDatum.editType = EditType.Delete;
                }

                setIonData(editedIonData);
            }
        }
    }
    */

    async function getIonData() {
        await CrudFunctions.getData(`benchsheets/iciondatabybenchsheetid/${props.benchSheetId}`)
            .then(data => {
                setIonData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Ion Data");
            });
    }

    async function getIonDataUoms() {
        await CrudFunctions.getData("benchsheets/samplepreparationuoms")
            .then(data => {
                setUoms(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving UOMs");
            });
    }

    //updates

    async function updateIonData(preparedIonData: IonChromatographyIonDatum[]) {
        return await CrudFunctions.putData("benchsheets/iciondata", preparedIonData);
    }

    /*
    function onIonDatumInfoButtonClick(e: any) {
        if (ionData) {
            let entry = ionData.find(p => p.ionChromatographyDataId === e.key)
            if (entry) {
                let itemBasicInformation: ItemBasicInformation = {
                    rowPointer: entry.ionChromatographyDataId,
                    createTimestamp: entry.createTimestamp,
                    lastModifiedTimestamp: entry.modifyTimestamp,
                    createUser: entry.createUser,
                    modifyUser: entry.modifyUser
                };

                setItemBasicInformation(itemBasicInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    //show/hide

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }
    

    function uomCellRender(e: any) {
        if (e.data && e.data.uom && e.data.uom.name) {
            return <div>{e.data.uom.name}</div>
        }
        else {
            return (
                <div></div>
            );
        }
    }
    */

    function editMarkerCellRender(e: any) {
        if (e.data) {
            switch (e.data.editType) {
                case EditType.Insert:
                    return <div><i className="dx-icon-add" /></div>;
                case EditType.Update:
                    return <div><i className="dx-icon-edit" /></div>;
                case EditType.Delete:
                    return <div><i className="dx-icon-trash" /></div>;
                default:
                    return <div></div>;
            }
        }
        return <div></div>;
    }

    async function getAllData() {
        await Promise.all([
            getIonDataUoms(),
            getIonData()
        ]);
    }
    
    function getRows() {
        let createdRows: Row[] = [];

        if (ionData) {
            createdRows = [
                headerRow,
                ...ionData.map<Row<DefaultCellTypes>>((ionDatum, idx) => ({
                    rowId: idx,
                    cells: [
                        { type: "text", text: ionDatum.ionChromatographyDataId ? ionDatum.ionChromatographyDataId : "", nonEditable: true, className: "reactgrid-hidden-column" },
                        { type: "text", text: "", nonEditable: true, className: getEditTypeTemplate(ionDatum) },
                        { type: "text", text: ionDatum.elution ? ionDatum.elution.toString() : "", className: "reactgrid-cell pw-bold reactgrid-horizontal-center" },
                        { type: "text", text: ionDatum.analyte ? ionDatum.analyte : "", className: "reactgrid-cell" },
                        { type: "text", text: ionDatum.resultString ? ionDatum.resultString : "", className: 'reactgrid-cell' },
                        { type: "text", text: ionDatum.retentionTime ? ionDatum.retentionTime.toString() : "", className: 'reactgrid-cell' },
                      //  { type: "text", text: "", nonEditable: true, }


                    ]

                    /*
                    ionChromatographyDataId ?: string;
                    benchSheetId ?: string;
                    elution ?: number | null;
                    analyte ?: string;
                    result ?: number | null;
                    uom ?: LookupItem;
                    uomId ?: number;
                    uomString ?: string;
                    uomUnit ?: number;
                    retentionTime ?: number | null;
                    */

                }))
            ];
        }
        else {
            let newIonData: IonChromatographyIonDatum[] = [];
            newIonData.push({ ionChromatographyDataId: new Guid().toString(), elution: 1, editType: EditType.Insert });

            setIonData(newIonData);
        }

        setRows(createdRows);
    }


    // show/hide
    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    //render

    function getEditTypeTemplate(ionDatum: IonChromatographyIonDatum) {
        switch (ionDatum.editType) {
            case EditType.None:
                return "";
            case EditType.Insert:
                return "reactgrid-add-icon";
            case EditType.Update:
                return "reactgrid-edit-icon";
            case EditType.Delete:
                return "reactgrid-delete-icon";
        }
    }
    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        if (reply.code === UNSAVED_CHANGES_WARNING) {
            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            closeDialog();
        }
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
